import {useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {
  InputNumberWrapper,
  SelectWrapper,
  InputDateWrapper,
} from '../../../../../../components/UI/Form/Input'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useApplication, useClient, useSite} from '../../../../hooks'
import {getFactConfigById} from '../../../../services/configFacturation.service'
import {TITLE_FORM_CONFIG_FACTURATION} from '../../../../util/Constants'
import {getOption} from '../../../../services'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {dateISOStringYMD} from '../../../../../../util/functions'
export const ConfigFacturationForm = () => {
  const {currentTabItem} = useCentral()
  const {clientList, getClientList} = useClient()
  const {siteList, getSiteList} = useSite()
  const {module, getModuleList} = useApplication()
  const [optionFather, setOptionFather] = useState<{value: string | number; label: string}[]>([])
  const [typeDat, setTypeDat] = useState<string | null>(null)
  const {typeData, getTypeDataList} = useTableForMaster()

  const {
    setValue,
    watch,
    setError,
    formState: {errors},
  } = useFormContext()
  console.log(errors)
  const getOptionList = async (id: any) => {
    try {
      const response = await getOption({aplicacionId: id}, 1, 1000)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id || '', label: item.nombre || ''}))
      setOptionFather(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }

  const getConfigDocsById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getFactConfigById(idToEdit as any)
        const {
          ClienteId,
          SiteId,
          ValorInicio,
          ValorFin,
          AplicacionId,
          FechaFin,
          FechaInicio,
          VistaPermisoId,
          TipoDatoId,
          TipoDatoNombre,
        } = data
        setValue('Id', idToEdit)
        setValue('ClienteId', ClienteId)
        setValue('SiteId', SiteId)
        setValue('AplicacionId', AplicacionId)
        setValue('VistaPermisoId', VistaPermisoId)
        setValue('TipoDatoId', TipoDatoId)
        setValue('FechaFin', dateISOStringYMD(FechaFin))
        setValue('FechaInicio', dateISOStringYMD(FechaInicio))
        setValue('ValorInicio', ValorInicio)
        setValue('ValorFin', ValorFin)
        if (TipoDatoNombre.toUpperCase().trim() === 'CORTE') {
          setTypeDat('02')
        } else {
          setTypeDat('01')
        }
        getSiteList({clienteId: ClienteId})
        getOptionList(AplicacionId)
      }
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }

  useEffect(() => {
    getClientList()
    getModuleList()
    getTypeDataList()
  }, [])
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getConfigDocsById()
    }
  }, [currentTabItem.idToEdit])

  let isDisabled = currentTabItem.idToEdit ? true : false

  const handleGetSiteList = async (val: any) => {
    let value = val ? val.value : ''
    getSiteList({clienteId: value})
  }
  const handleGetOptions = (val: any) => {
    let data = val ? val : ''
    getOptionList(data.value)
  }

  const handleGetTypeData = (val: any) => {
    let data = val ? val : ''
    setTypeDat(data.codigo)
    setValue('TipoDatoId', data.value)
    setValue('ValorInicio', '')
    setError('ValorInicio', {})
    setValue('ValorFin', undefined)
    setError('ValorFin', {})
  }

  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_CONFIG_FACTURATION}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={clientList}
            disabled={isDisabled}
            onChangeValue={handleGetSiteList}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={siteList}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Módulo'
            name='AplicacionId'
            data={module}
            onChangeValue={handleGetOptions}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Menú principal' name='VistaPermisoId' data={optionFather} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de dato'
            name='TipoDatoId'
            data={typeData}
            onChangeValue={handleGetTypeData}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText={typeDat === '01' ? 'Día Inicio' : 'Días'}
            name='ValorInicio'
            textPlaceholder='Escribe el dia inicio'
            required
          />
        </div>
        {typeDat === '01' && (
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <InputNumberWrapper
              labelText='Día Fin'
              name='ValorFin'
              textPlaceholder='Escribe el dia fin'
              required
            />
          </div>
        )}
      </div>
    </ContentForm>
  )
}
